import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MinusSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusSquareOutlined";
import AntdIcon from "../components/AntdIcon";
var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusSquareOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MinusSquareOutlined.displayName = 'MinusSquareOutlined';
}
export default /*#__PURE__*/React.forwardRef(MinusSquareOutlined);